import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}
const delink = (deviceid: string, mid: string, deviceType: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(deviceType === 'POS' ? APIEndPoints.delink : APIEndPoints.voiceBoxDlink),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),

    //headers: { ...getHeaders(), 'x-user-id': 'test', 'x-channel-id': '322287787654' },
    body: {
      deviceid,
      mid,
      deviceId: deviceid,
    },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
export { delink }
